import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { createContext } from 'react';

const Context = createContext<LDFlagSet>({});

export default Context;
